import { useState } from "react";
import { Btn, Inp, Marca } from "../components/primitives";

const HASH = "cc5a1c55d784e6ca089e598f1da06bd3fc04145a997b8b75ff207a28b9e6b14d";

async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function LoginView({ onAuth }) {
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState(false);
  const [loading, setLoading] = useState(false);

  async function entrar(e) {
    e.preventDefault();
    setLoading(true);
    setErro(false);
    const hash = await sha256(senha);
    if (hash === HASH) {
      localStorage.setItem("rc2_auth", "1");
      onAuth();
    } else {
      setErro(true);
      setSenha("");
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)", padding: 16 }}>
      <div style={{ width: "100%", maxWidth: 380, display: "grid", gap: 16 }}>
        <section className="stage" style={{ gap: 14, textAlign: "left" }}>
          <div className="stage-path">
            <i style={{ background: "#FF5F57" }} /><i style={{ background: "#FEBC2E" }} /><i style={{ background: "#28C840" }} />
            <span>rc2@crm: ~/<b>entrar</b></span>
          </div>
          <Marca fundo="escuro" height={30} />
          <h1 style={{ fontSize: 26 }}>Acesso <span className="hl">restrito</span></h1>
        </section>

        <form onSubmit={entrar} className="card card-pad" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <label className="field-label" htmlFor="rc2-senha">Senha</label>
          <Inp
            id="rc2-senha"
            type="password"
            placeholder="Senha"
            value={senha}
            onChange={(e) => { setSenha(e.target.value); setErro(false); }}
            autoFocus
            autoComplete="current-password"
            className={erro ? "is-error" : ""}
          />

          {erro && (
            <div role="alert" style={{ fontSize: "var(--t-xs)", color: "var(--danger)", textAlign: "center" }}>
              Senha incorreta
            </div>
          )}

          <Btn variant="primary" full disabled={!senha || loading} style={{ padding: "12px" }}>
            {loading ? "Verificando..." : "Entrar"}
          </Btn>
        </form>
        <div className="eyebrow" style={{ textAlign: "center" }}>RC2Clicks CRM</div>
      </div>
    </div>
  );
}
